import * as React from "react";
import { UserGoalView, Goal } from "@curefit/gmf-common";
import AppLoader from "../../components/utils/AppLoader";
import {EpochConstants, LOADING_STATE} from "../../utils/AppUtils";
import EditViewCard, {EditViewDisplayMode} from "../../components/common/EditViewCard";
import * as _ from "lodash";
import ModelFactory from "../../models/ModelFactory";
import IMetric from "../../models/metrics/IMetric";

interface OtherHealthTargetsEditViewProps {
    goalsType?: string;
    doctorId?: number;
    appointmentId?: number;
    patientId: number,
    secondaryUserId: string,
    patientGoals: UserGoalView[],
    staticGoals: Goal[],
    staticMetrics: IMetric[],
    fetchPlanStaticData: () => void,
    fetchPatientAllergies?: (patientId: number) => any,
    savePatientGoalsEdit?: (patientId: number, req: any) => any,
    displayMode?: EditViewDisplayMode,
    titleToDisplay?: string,
    preventGoalAddition?: boolean,
    isSelf: boolean;
}
interface OtherHealthTargetsEditViewStates {
    savedGoals: {item: UserGoalView}[];
    updatedGoals: {item: UserGoalView}[];
    isStaticGoalsAndMetricsLoaded: LOADING_STATE;
    isHealthTargetDataLoaded: LOADING_STATE;
}
export default class OtherHealthTargetsEditViewCont extends React.Component<OtherHealthTargetsEditViewProps, OtherHealthTargetsEditViewStates> {
    constructor(props: OtherHealthTargetsEditViewProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }
    componentWillReceiveProps(newProps: OtherHealthTargetsEditViewProps) {
        this.setState(this.getStateFromProps(newProps));
    }
    getUpdatedGoalsFromProps = (props: OtherHealthTargetsEditViewProps): {item: UserGoalView}[] => {
        let currUpdatedAllergies: {item: UserGoalView}[] = []
        _.map(props.patientGoals, function(patientGoal){
            // if (_.isEmpty(patientGoal._id)) {
            let clonePatientGoal = Object.assign({}, patientGoal)
            currUpdatedAllergies.push({item: clonePatientGoal})
            // }
        })
        return currUpdatedAllergies
    }
    getUpdatedSavedGoalsFromProps = (props: OtherHealthTargetsEditViewProps): {item: UserGoalView}[] => {
        let currUpdatedAllergies: {item: UserGoalView}[] = []
        _.map(props.patientGoals, function(patientGoal){
            if (!_.isEmpty(patientGoal._id)) {
                let clonePatientGoal = Object.assign({}, patientGoal)
                currUpdatedAllergies.push({item: clonePatientGoal})
            }
        })
        return currUpdatedAllergies
    }
    getStateFromProps = (props: OtherHealthTargetsEditViewProps) => {
        let currState: OtherHealthTargetsEditViewStates = {
            savedGoals: [],
            updatedGoals: [],
            isHealthTargetDataLoaded: LOADING_STATE.NOT_INITIALIZED,
            isStaticGoalsAndMetricsLoaded: LOADING_STATE.NOT_INITIALIZED
        }
        if ( _.isNull(props.patientGoals) ) {
            props.fetchPatientAllergies(this.props.patientId)
            currState.isHealthTargetDataLoaded = LOADING_STATE.LOADING
        } else {
            currState.updatedGoals = []
            _.map(props.patientGoals, function(patientGoal) {
                if (!_.isEmpty(patientGoal._id)) {
                    let clonePatientGoal = Object.assign({}, patientGoal);
                    if (!_.isEmpty(patientGoal.editInfo) && !_.isEmpty(patientGoal.editInfo.nextGoalMetricTargets)) {
                        clonePatientGoal.goalMetricTargets = patientGoal.editInfo.nextGoalMetricTargets;
                    }
                    currState.savedGoals.push({item: clonePatientGoal})
                } else {
                    let clonePatientGoal = Object.assign({}, patientGoal);
                    if (!_.isEmpty(patientGoal.editInfo) && !_.isEmpty(patientGoal.editInfo.nextGoalMetricTargets)) {
                        clonePatientGoal.goalMetricTargets = patientGoal.editInfo.nextGoalMetricTargets;
                    }
                    currState.updatedGoals.push({item: clonePatientGoal})
                }
            })
            currState.isHealthTargetDataLoaded = LOADING_STATE.LOADED
        }

        if (_.isEmpty(props.staticGoals) || _.isEmpty(props.staticMetrics)) {
            this.props.fetchPlanStaticData();
            currState.isStaticGoalsAndMetricsLoaded = LOADING_STATE.LOADING;
        } else {
            currState.isStaticGoalsAndMetricsLoaded = LOADING_STATE.LOADED;
        }
        return currState
    }
    getHealthTargetEditViewProps = () => {
        let healthTargetViewProps = {
            goalsType: this.props.goalsType,
            staticGoals: this.props.staticGoals,
            staticMetrics: this.props.staticMetrics,
            updatedGoals: this.state.updatedGoals,
            savedGoals: this.state.savedGoals,
            updateGoals: this.updateGoals,
            updateSavedGoals: this.updateSavedGoals,
            isOnlyEdit: this.props.preventGoalAddition
        };
        let healthTargetEditProps = {
            goalsType: this.props.goalsType,
            staticGoals: this.props.staticGoals,
            staticMetrics: this.props.staticMetrics,
            updatedGoals: this.state.updatedGoals,
            savedGoals: this.state.savedGoals,
            updateGoals: this.updateGoals,
            updateSavedGoals: this.updateSavedGoals,
            deleteGoal: this.deleteGoal,
            isOnlyEdit: this.props.preventGoalAddition
        };
        return {view: healthTargetViewProps, edit: healthTargetEditProps};
    }
    updateSavedGoals = (updatedGoals: {item: UserGoalView}[]) => {
        this.setState({savedGoals: updatedGoals})
    }
    updateGoals = (updatedGoals: {item: UserGoalView}[]) => {
        this.setState({updatedGoals: updatedGoals})
    }
    cancelSavedActionHandler = () => {
        this.setState({savedGoals: this.getUpdatedSavedGoalsFromProps(this.props)})
    }
    cancelActionHandler = () => {
        this.setState({updatedGoals: this.getUpdatedGoalsFromProps(this.props)})
    }
    deleteGoal = (goal: UserGoalView) => {
        let myInstance = this;
        let healthTargetSource = {
            serviceId: "DOCSAPP",
            serviceRefId: `CONS-${this.props.appointmentId}`,
            userType: "DOCTOR",
            userRefId: this.props.doctorId.toString()
        }
        let healthTargetSaveObject = {
            source: healthTargetSource,
            userGoalEdits: [{
                userGoalId: goal._id,
                editInfo: {
                    nextStatus: goal.editInfo.nextStatus,
                    nextGoalMetricTargets: goal.goalMetricTargets
                }
            }]
        }
        return this.props.savePatientGoalsEdit(this.props.patientId, healthTargetSaveObject);
    }
    saveHealthTarget = () => {
        let myInstance = this;
        let healthTargetSource = {
            serviceId: "DOCSAPP",
            serviceRefId: `CONS-${this.props.appointmentId}`,
            userType: "DOCTOR",
            userRefId: this.props.doctorId.toString()
        }
        let nextStatus = !_.isEmpty(this.state.updatedGoals[0].item.editInfo) && !_.isEmpty(this.state.updatedGoals[0].item.editInfo.nextStatus) &&
        this.state.updatedGoals[0].item.editInfo.nextStatus === "CANCELLED" ? "CANCELLED" : "LIVE";
        let healthTargetSaveObject = {
            source: healthTargetSource,
            userGoalEdits: [{
                userGoalId: this.state.updatedGoals[0].item._id,
                editInfo: {
                    nextStatus,
                    nextGoalMetricTargets: this.state.updatedGoals[0].item.goalMetricTargets
                }
            }]
        }
        this.setState({isHealthTargetDataLoaded: LOADING_STATE.NOT_INITIALIZED}, () => {
            this.props.savePatientGoalsEdit(this.props.patientId, healthTargetSaveObject).then(function(){
                myInstance.setState({isHealthTargetDataLoaded: LOADING_STATE.LOADED})
            })
        });
        // Save health target
    }
    isFormDirty = (): boolean => {
        let status = false;
        let erronousRows: number[] = [];
        let goalType = this.props.goalsType;
        _.map(this.state.updatedGoals, function(updateGoalItem: {item: UserGoalView}, index: number){
            if (!ModelFactory.isValidGoal(updateGoalItem.item, goalType)) {
                status = true;
                erronousRows.push(index + 1);
                return false;
            }
        })
        return status;
    }

    dirtyFormText = (): string => {
        let erronousRows: number[] = [];
        _.map(this.state.updatedGoals, function(updatedGoalItem: {item: UserGoalView}, index: number){
            if (!ModelFactory.isValidGoal(updatedGoalItem.item)) {
                erronousRows.push(index + 1);
                return false;
            }
        })
        let errorText = `Missing goal name/metric`;
        return errorText;
    }
    getSaveObject = () => {
        let patientId = this.props.patientId;
        let appointmentId = this.props.appointmentId;
        let isSelf = this.props.isSelf;
        let secondaryUserId = this.props.secondaryUserId;
        let goalsType = this.props.goalsType;
        let saveGoalList: UserGoalView[] = []
        _.map(this.state.updatedGoals, function(updatedGoalItem: {item: UserGoalView}){
            if (!ModelFactory.isGoalItemEmpty(updatedGoalItem.item, goalsType)) {
                let goalItem = updatedGoalItem.item;
                if (goalItem.startEpoch === null) {
                    goalItem.startEpoch = new Date().getTime();
                    goalItem.endEpoch = new Date().getTime() + (EpochConstants.EPOCH_IN_AN_DAY * 30 * 12);
                }
                goalItem.secondaryUserId = secondaryUserId;
                goalItem.editInfo = { nextStatus: "LIVE" };
                goalItem.status = "DRAFT";
                goalItem.userGoalType = goalsType;
                goalItem.durationInDays = 30 * 12;
                goalItem.isSelf = isSelf;
                if (goalsType === "OTHER") {
                    delete goalItem.userId;
                    delete goalItem.goalId;
                    delete goalItem.goalMetricTargets;
                }
                saveGoalList.push(goalItem);
            }
        })
        _.map(this.state.savedGoals, (updatedGoalItem: {item: UserGoalView}) => {
            let updatedItem = { ...updatedGoalItem.item };
            saveGoalList.push(updatedItem);
        })
        return saveGoalList;
    }
    render() {
        let isHealthTargetLoaded = this.state.isHealthTargetDataLoaded === LOADING_STATE.LOADED && this.state.isStaticGoalsAndMetricsLoaded === LOADING_STATE.LOADED;
        let titleToDisplay = !_.isEmpty(this.props.titleToDisplay) ? this.props.titleToDisplay : "Health Targets";
        return <div className="health-target-container">
            {isHealthTargetLoaded && <EditViewCard cardTitleDisplay={titleToDisplay} templateName={"otherHealthTarget"}
                                                   templateProps={this.getHealthTargetEditViewProps()}
                                                   lastEditedEpoch={new Date().getTime()} saveActionHandler={this.saveHealthTarget}
                                                   cancelActionHandler={this.cancelActionHandler}
                                                   displayMode={this.props.displayMode}
            />}
            {!isHealthTargetLoaded && <AppLoader/>}
        </div>
    }
}